import { render, staticRenderFns } from "./TemplateReports.vue?vue&type=template&id=59bc64f4&scoped=true"
import script from "./TemplateReports.vue?vue&type=script&lang=ts"
export * from "./TemplateReports.vue?vue&type=script&lang=ts"
import style0 from "./TemplateReports.vue?vue&type=style&index=0&id=59bc64f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc64f4",
  null
  
)

export default component.exports